import { OptionalString } from '@/app/core';
import { stringUtils } from '@/app/core/utils';
import { HasFieldLength } from '@ssar-app/domain';

export enum FieldsConsumerAggregateError {
  ConsumerAddressMinimums,
  ConsumerNameMinimums,
  ConsumerAddressCombinations,
  ConsumerNameCombinations,
  ConsumerAddressCompleteness,
}

export const validFieldsConsumerAggregateErrors = Object.keys(
  FieldsConsumerAggregateError,
).filter((a) => !stringUtils.isNumeric(a));

export const hasFieldsConsumerAggregateError = (
  errorStrings: string[],
  errorCode: FieldsConsumerAggregateError,
): boolean => {
  return errorStrings.includes(FieldsConsumerAggregateError[errorCode]);
};
export const passThroughValue = '';

export interface FieldHeaderMapping {
  experianHeader: OptionalString;
  clientHeader: string;
}

// export interface FieldHeaderData extends FieldHeaderMapping {
//   snapshotHeader: OptionalString;
// }

export interface FieldHeadersMappingsMap {
  field: string;
  fieldHeaderMapping: FieldHeaderMapping;
}

export interface HeaderNameWithLength extends HasFieldLength {
  name: OptionalString;
}

export interface FieldMappings {
  field: string;
  headerNameWithLength: HeaderNameWithLength;
}

export interface InputFileUploadResult {
  experianFileName: string;
  clientFileName: string;
  fieldMappings: FieldMappings[];
  recordsExpected?: number;
  hasHeaders?: boolean;
  intentType?: string;
}

export interface StringToBooleanMap {
  header: string;
  status: boolean;
}

export interface PreviousFieldMappings {
  field: string;
  previousHeader: OptionalString;
}

export type FieldError = {
  message: string;
  type: string;
};
